export default __webpack_public_path__ + "static/media/logo.bb8aa703.svg";